import { useAppConfigContext } from '#/src/appConfig'

/**
 * Client-side access to the active per-locale app config. Reads the per-request
 * dynamic config from context (provided by the layout via `getDynamicAppConfig`),
 * so all consumers reflect live store settings without a redeploy. Falls back to
 * the default-locale build-time config outside a provider.
 */
const useAppConfig = () => useAppConfigContext()

export default useAppConfig
